import React, { Component } from 'react';
import { WholeInputSearch } from './WholeInputSearch';
import { ExcelUpLoad } from './ExcelUpLoad';
import { OrderSelect } from './OrderSelect';
import { Big3Common, bootstrap } from '../../../js/IncludeManager'
import { Alert, Confirm } from "../../../js/ComponentManager";
/* 개발담당:양유빈
 * 화면기능:엑셀등록 테이블
 * 세부설명:
*/

export class OrderExcelTable extends Component {
    static displayName = OrderExcelTable.name;

    constructor(props) {
        super(props);
        this.state = {
            WholeDataList: [],
            Order_Dt: "",    //주문일
            this_Dt:"",
            Content: "",
            ButtonHidden: false,
            isOk: false
        }; 
        this.ref_WholeInputSearch = React.createRef();
        this.ref_ExcelUpLoad = React.createRef();
        this.ref_OrderSelect = React.createRef();
        this.handleWholeSearch_Click = this.handleWholeSearch_Click.bind(this);
        this.handleDelete_Click = this.handleDelete_Click.bind(this);
        this.handleCheck_Click = this.handleCheck_Click.bind(this);
        this.handleTextBox_Blur = this.handleTextBox_Blur.bind(this);
        this.handleSave_Click = this.handleSave_Click.bind(this);       
        this.handleDownload_Click = this.handleDownload_Click.bind(this);
        this.handleExcelUpLoad_Click = this.handleExcelUpLoad_Click.bind(this);
        this.handleBookCal_Click = this.handleBookCal_Click.bind(this);
        this.handleOrderSelect_Click = this.handleOrderSelect_Click.bind(this);
        this.Uid_Type = Big3Common.WebStorage.GetLocalStorage(Big3Common.WebStorage.StorageName.Uid_Type)
    }
    WholeModel = {
        selected: "N",
        order_code:"",
        whole_code:"",
        order_dt:"",
        retail_memo:"",
        return_yn:"N",
        order_conf_yn: "N",
        kakao_send_yn: "N",
        bld_name: "",
        flr_name: "",
        whole_no_name: "",
        whole_name: "",
        user_phone: "",
        isvalid: "N",
        crud:"C"
    }
    
    //초기화
    async componentDidMount() {
        let wrap = document.querySelector("#wrap");
        if (wrap !== undefined) {
            wrap.setAttribute("id", "wrap2");
        }
        let header = document.querySelector("header");
        if (header !== undefined) {
            header.setAttribute("class", "header_v2");
        }

        const ToDate = await Big3Common.Get('api/Common/Common/GetOrderDate');
        if (ToDate.codeName === Big3Common.ResultCode.Success) {
            //오늘기준 주문일자(불변)
            this.setState({ Order_Dt: ToDate.message, this_Dt: ToDate.message });
        }
        
        if (Big3Common.Util.GetContentState(this.props.ContentState, "Order_Dt", "") === "") {
            //[주문등록버튼]으로 클릭하고 들어올때 날짜에 해당하는 데이터가 있으면 조회
            this.CallOrderExcelDtlList(ToDate.message);
        }
        else if (Big3Common.Util.GetContentState(this.props.ContentState, "Order_Dt", "") !== "") {
            //세부내역을 클릭하고 들어올때 저장내역 조회
            const Order_Dt = this.props.ContentState.Order_Dt;
            this.CallOrderExcelDtlList(Order_Dt);
            if (ToDate.message === Order_Dt) {
                //같은날
                this.setState({ Order_Dt: Order_Dt });
            }
            else {
                //다른날
                this.setState({ Order_Dt: Order_Dt, ButtonHidden: true });
            }
            
        }
    }
    //사입 주문내역 상세 리스트
    CallOrderExcelDtlList = async (Order_Dt) => {
        try {
            Big3Common.Util.LoadingOn();
            let Data = await Big3Common.Post('api/MyPage/ExcelOrder/GetOrderExcelDtlList',
                {
                    order_dt: Order_Dt
                });
            if (Data.codeName === Big3Common.ResultCode.Success) {
                const WholeDataList = JSON.parse(Data.dataTable);
                this.setState({
                    WholeDataList: WholeDataList
                });
            }
        }
        catch (e) {
            console.log("CallOrderExcelDtlList", e);
        }
        finally {
            Big3Common.Util.LoadingOff();
        }
    }
    //콤퍼넌트 해제
    componentWillUnmount() {
        let wrap = document.querySelector("#wrap2");
        if (wrap !== undefined) {
            wrap.setAttribute("id", "wrap");
        }  
    } 
    //내용입력 버튼 클릭(팝업호출)
    handleWholeSearch_Click = (event) => {
        if (!this.DateCheck()) {
            return false;
        }
        this.ref_WholeInputSearch.current.initWholeSearch();
        Big3Common.ModalAlert(bootstrap, 'WholeInputSearch');
        event.preventDefault();
    }
    //엑셀파일 업로드 오픈
    handleExcelUpLoad_Click = (event) => {
        if (!this.DateCheck()) {
            return false;
        }
        this.ref_ExcelUpLoad.current.initExcelUpLoad();
        Big3Common.ModalAlert(bootstrap, 'ExcelUpLoad');
        event.preventDefault();
    }
    //최근내역 불러오기 오픈
    handleOrderSelect_Click = (event) => {
        if (!this.DateCheck()) {
            return false;
        }
        this.ref_OrderSelect.current.initOrderSelect();
        Big3Common.ModalAlert(bootstrap, 'OrderSelect');
        return false;
    }
    //주문일자와 사입가능일자 검증
    DateCheck = () => {
        if (this.state.Order_Dt !== this.state.this_Dt) {
            this.setState({ Content: `등록된 주문 일자는 ${this.state.Order_Dt}일 이며, 주문 가능일자는 ${this.state.this_Dt}입니다.` });
            Big3Common.ModalAlert(bootstrap, 'AlertOrderExcelTable');
            return false;
        }
        return true;
    }
    //행삭제
    async handleDelete_Click(list) {
        let DeleteList = [];
        if (list !== undefined) {
            DeleteList.push(list);
        }
        else {
            DeleteList = this.state.WholeDataList.filter(list => list.selected === "Y");
        }
        let DelParams = [];
         
        if (DeleteList.length === 0) {
            this.setState({ Content: "삭제할 항목이 없습니다." });
            Big3Common.ModalAlert(bootstrap, 'AlertOrderExcelTable');
            return false;
        }
        //단순입력 삭제
        const DeleList_C = DeleteList.filter(list => list.crud === "C");
        if (DeleList_C.length > 0) {
            DeleList_C.map(delList => Big3Common.Util.RemoveModelListRow(this.state.WholeDataList, "whole_code", delList.whole_code));
            this.setState({ isOk: true });
        }
        //DB입력 삭제, order_conf_yn은 "N"인 상태
        const DeleList_U = DeleteList.filter(list => list.crud === "U" && list.order_conf_yn === "N");
        if (DeleList_U.length > 0) {
            DeleList_U.map(delList => {
                    DelParams.push({
                    union_uid: delList.union_uid,
                    whole_code: delList.whole_code,
                    order_dt: delList.order_dt,
                    order_conf_yn: delList.order_conf_yn
                });
                return false;
            });
            try {
                let Model = { dellist: DelParams };
                let Data = await Big3Common.Post('api/MyPage/ExcelOrder/RemoveOrderExcelSingle', Model);
                this.setState({ Content: Data.message });
                Big3Common.ModalAlert(bootstrap, 'AlertOrderExcelTable');
                this.CallOrderExcelDtlList(this.state.Order_Dt);
            }
            catch (e) {
                console.log("handleDelete_Click", e);
            }
        }        
        return false;
    }
    handleTextBox_Blur(event, list) {
        if (list.order_conf_yn === "Y") return false;
        list.retail_memo = event.target.value;
        this.setState({ isOk: true });
        return false;
    }
    //반품여부, 알립톡 체크
    handleCheck_Click(event, list = null) {
       
        const Checked = event.target.checked === true ? "Y" : "N";
        if (list === null) {
            //전송완료 되지 않은 항목만
            const TagID = event.target.id;
            if (TagID === "alldel") {
                this.state.WholeDataList.filter(data => data.order_conf_yn==="N").map((data) => data.selected = Checked);
            }
            else if (TagID === "allreturn") {
                this.state.WholeDataList.filter(data => data.order_conf_yn === "N").map((data) => data.return_yn = Checked);
            }
            
        }
        else {
            if (list.order_conf_yn === "Y") {
                return false;
            }
            const TagName = event.target.name;
            if (TagName === "Return_Yn") {
                list.return_yn = Checked;
            }
            
            else if (TagName === "Selected") {
                list.selected = Checked;
            }
        }
        this.setState({ isOk: true });
        return false;
    }
    //엑셀양식 다운로드
    handleDownload_Click = async (event) => {
        try {
            const fileName = "클로디_대량주문_Sample.xlsx";
            let Url = "api/MyPage/ExcelOrder/ExcelSampleDownload"
            await Big3Common.FileDownLoad(Url, fileName);
        }
        catch (e) {
            console.log("handleDownLoad_Click", e);
        }
        event.preventDefault();
    }
    //찜한매장 불러오기
    handleBookCal_Click = async () => {
        try {
            Big3Common.Util.LoadingOn();
            let Data = await Big3Common.Get('api/MyPage/ExcelOrder/GetBokmkStoreToWholecode');
            if (Data.codeName === Big3Common.ResultCode.Success) {
                const DataList = Data.objectData;
                if (DataList.length > 0) {
                    let WholeDataList = this.state.WholeDataList;
                    const Order_Dt = this.state.Order_Dt;
                    DataList.map(list => {
                        //동일 도매 중복제거
                        const Whole_Code_Count = WholeDataList.filter(wholes => wholes.whole_code === list.whole_code).length;
                        if (Whole_Code_Count === 0) {
                            let CloneModel = { ...this.WholeModel}
                            CloneModel.order_dt = Order_Dt;
                            CloneModel.bld_name = list.bld_name;
                            CloneModel.flr_name = list.flr_name;
                            CloneModel.whole_no_name = list.whole_no_name;
                            CloneModel.whole_name = list.whole_name;
                            CloneModel.user_phone = list.user_phone;
                            CloneModel.whole_code = list.whole_code;
                            CloneModel.isvalid = "Y";
                            WholeDataList.push(CloneModel);
                        }
                        return false;
                    });
                    this.setState({ WholeDataList: WholeDataList });
                }
            }
        }
        catch (e) {
            console.log("CallOrderExcelDtlList", e);
        }
        finally {
            Big3Common.Util.LoadingOff();
        }
    }
    //사입저장
    async handleSave_Click(flag) {

        //전송하지 않은 항목들 중
        const WholeDataList = this.state.WholeDataList.filter(list => list.order_conf_yn === "N"); 
        //검증되지 않은 항목
        const NoValidCount = WholeDataList.filter(list => list.isvalid === "N").length;
        //const UserPhonList = Big3Common.Util.groupBy(WholeDataList, list => list.user_phone);
        //let DuplicatePhone = "";
        if (WholeDataList.length === 0) {
            this.setState({ Content: flag === "send" ? (this.Uid_Type === 'SS' ? "사입요청할 내역이 없습니다." : "택배요청할 내역이 없습니다.") : "저장할 내용이 없습니다." });
            Big3Common.ModalAlert(bootstrap, 'AlertOrderExcelTable');
            return false;
        }
        if (NoValidCount > 0) {
            this.setState({ Content: "미검증 항목은 삭제 후 진행해 주세요." });
            Big3Common.ModalAlert(bootstrap, 'AlertOrderExcelTable');
            return false;
        }
        if (!this.DateCheck()) {
            return false;
        }
        
        try {
            Big3Common.Util.LoadingOn();
            //flag는 temp와 send로 구분
            let Model = { excellist: WholeDataList, "flag": flag };
            let Data = await Big3Common.Post('api/MyPage/ExcelOrder/RegisterOrderExcel', Model);

            if (Data.codeName === Big3Common.ResultCode.Etc1) {
                //사입주문시간이 벗어날경우
                this.setState({ Content: Data.message });
                Big3Common.ModalAlert(bootstrap, 'AlertOrderExcelTable');
            }
            else {
                this.setState({ Content: Data.message });
                Big3Common.ModalAlert(bootstrap, 'AlertOrderExcelTable');
                this.CallOrderExcelDtlList(this.state.Order_Dt);
            }
        }
        catch (e) {
            console.log("handleSave_Click", e);
        }
        finally {
            Big3Common.Util.LoadingOff();
        }
         
        return false;
    }
    //등록이력 불러오기
    CallOrderSelect = (DataList) => {
        if (DataList.length > 0) {
            let WholeDataList = this.state.WholeDataList;
            const Order_Dt = this.state.Order_Dt;
            DataList.map(list => {
                //동일 도매 중복제거
                const Whole_Code_Count = WholeDataList.filter(wholes => wholes.whole_code === list.whole_code).length;
                if (Whole_Code_Count === 0) {
                    let CloneModel = { ...this.WholeModel };
                    CloneModel.order_dt = Order_Dt;
                    CloneModel.bld_name = list.bld_name;
                    CloneModel.flr_name = list.flr_name;
                    CloneModel.whole_no_name = list.whole_no_name;
                    CloneModel.whole_name = list.whole_name;
                    CloneModel.user_phone = list.user_phone;
                    CloneModel.whole_code = list.whole_code;
                    CloneModel.isvalid = "Y";
                    WholeDataList.push(CloneModel);
                }
                return false;
            });
            this.setState({ WholeDataList: WholeDataList });
        }
        Big3Common.ModalClose(bootstrap, 'OrderSelect');
        return false;
    }
    //팝업창 검색결과 반환
    CallWholeListData = (DataList, Retail_Memo) => {
        if (DataList.length > 0) {
            let WholeDataList = this.state.WholeDataList;
            const Order_Dt = this.state.Order_Dt;
            DataList.map(list => {
                //동일 도매 중복제거
                const Whole_Code_Count = WholeDataList.filter(wholes => wholes.whole_code === list.whole_code).length;
                if (Whole_Code_Count === 0) {
                    let CloneModel = { ...this.WholeModel };
                    CloneModel.order_dt = Order_Dt;
                    CloneModel.bld_name = list.bld_name;
                    CloneModel.flr_name = list.flr_name;
                    CloneModel.whole_no_name = list.whole_no_name;
                    CloneModel.whole_name = list.whole_name;
                    CloneModel.user_phone = list.user_phone;
                    CloneModel.whole_code = list.whole_code;
                    CloneModel.retail_memo = Retail_Memo || "";
                    CloneModel.return_yn = list.return_yn;
                    CloneModel.isvalid = "Y";
                    CloneModel.crud = "C";
                    WholeDataList.push(CloneModel);
                }
                return false;
            });
            this.setState({ WholeDataList: WholeDataList });
        }
    }
    //팝업창 엑셀결과 반환
    CallExcelWholeListData = (DataTable) => {
        if (DataTable.length > 0) {
            this.setState({ WholeDataList: DataTable });
        }
        return false;
    }
    Listrender() {
        const WholeDataList = this.state.WholeDataList;
        this.PhoneCount = (Phone) => {
            return WholeDataList.filter(list => list.user_phone === Phone).length;
        }
        return (
            WholeDataList.map((list,idx) =>
                <tr key={idx+1 }>
                    <td>
                        <input
                            className="form-check-input"
                            type="checkbox"
                            name="Selected"
                            checked={list.selected === "Y" ? true : false}
                            onChange={(e) => { this.handleCheck_Click(e, list) }}
                            readOnly={list.order_conf_yn === "Y" ? true : false}
                        />                         
                    </td>
                    <td>{idx+1}</td>
                    <td>{list.order_conf_yn === "Y" ? "완료" : "작업중"}</td>
                    <td>{list.whole_name}</td>
                    <td>{list.bld_name}</td>
                    <td>{list.flr_name}</td>
                    <td>{list.whole_no_name}</td>
                    <td>{this.PhoneCount(list.user_phone) > 1 ? <div style={{ color: '#d94545' }}>{list.user_phone}</div> : list.user_phone} </td>
                    <td>
                        <input type="text"
                            className="table_input"
                            defaultValue={list.retail_memo || ""}
                            onBlur={(e) => { this.handleTextBox_Blur(e, list); }}
                            readOnly={list.order_conf_yn === "Y" ? true : false}
                        />
                    </td>
                    <td>
                        <input
                            className="form-check-input"
                            type="checkbox"
                            name="Return_Yn"
                            checked={list.return_yn === "Y" ? true : false}
                            onChange={(e) => { this.handleCheck_Click(e, list) }}
                            readOnly={list.order_conf_yn === "Y" ? true : false}
                        />

                    </td>
                     
                    <td>
                        {list.isvalid === "Y" ? <button className="shop_nc" style={{ cursor:"default" }}>매장확인</button> : <button className="shop_c" onClick={() => this.handleDelete_Click(list)}>미확인</button>}
                    </td>
                </tr>
            )
        )
    }
    render() {
        const Listrender = this.Listrender();
        this.ButtonTop = () => {
            if (this.state.ButtonHidden) return false;

            return (
                <div className="excel_data_upload_btn_box">
                    <div className="upload_btn" onClick={(e) => { this.handleWholeSearch_Click(e) }}>
                        <span className="plus_data"></span>
                        <p>주문입력</p>
                    </div>
                    <div className="upload_btn upload_btn2" onClick={() => { this.handleDelete_Click(); }}>
                        <span className="minus_data"></span>
                        <p>주문서삭제</p>
                    </div>
                    <div className="upload_btn upload_btn4" onClick={() => { this.handleBookCal_Click(); }}>
                        <span className="zzim_data"></span>
                        <p>찜한매장 불러오기</p>
                    </div>
                    <div className="upload_btn upload_btn5" onClick={() => { this.handleOrderSelect_Click(); } }>
                        <span className="last_data"></span>
                        <p>최근내역 불러오기</p>
                    </div>
                </div>
            )
        }
        this.ButtonBottom = () => {
            if (this.state.ButtonHidden) return false;
            return (
                <div className="excel_data_upload_btn_box excel_data_upload_btn_box2">
                    <div className="flex_box">
                        <div className="upload_btn" onClick={(e) => { this.handleWholeSearch_Click(e) }}>
                            <span className="plus_data"></span>
                            <p>주문입력</p>
                        </div>
                        <div className="upload_btn upload_btn2" onClick={() => { this.handleDelete_Click(); }}>
                            <span className="minus_data"></span>
                            <p>주문서삭제</p>
                        </div>
                    </div>
                    <div className="flex_box">
                        {this.Uid_Type === 'SS' ? (
                            <div className="upload_btn upload_btn3" onClick={() => { Big3Common.ModalAlert(bootstrap, 'ConfirmBox'); }}>
                                <p>사입요청</p>
                            </div>
                        ): (
                            <div className="upload_btn upload_btn3" onClick={() => { Big3Common.ModalAlert(bootstrap, 'ConfirmBox'); }}>
                                <p>택배요청</p>
                            </div>
                        )}
                        <div className="upload_btn upload_btn2" onClick={() => { this.handleSave_Click('temp') }}>
                            <p>임시저장</p>
                        </div>
                    </div>
                </div>
            )
        }
        return (
            <div className="container_box3  p_b_margin">
                <div className="excel_data_info">
                    <div className="excel_data_date">주문일: {this.state.Order_Dt}</div>
                    <div className="excel_order_btn_box excel_order_btn_box_v2">
                        <div className="excel_order_btn  excel_order_btn_v2" onClick={(e) => { this.handleDownload_Click(e); } }>
                            <span className="excelicon"></span>
                            <p>엑셀양식 다운로드</p>
                        </div>
                        <div className="excel_order_btn excel_order_btn_v2" onClick={(e) => { this.handleExcelUpLoad_Click(e); }}> 
                            <span className="upload"></span>
                            <p>일괄주문 등록</p>
                        </div>
                    </div>
                </div>
                <div className="line_v2"></div>
                {this.ButtonTop()}
                <div className="excel_table_box">
                    <table>
                        <caption>주문목록</caption>
                        <colgroup>
                            <col width="50px;" />
                            <col width="50px;" />
                            <col width="60px;" />
                            <col width="12%;" />
                            <col width="12%;" />
                            <col width="80px;" />
                            <col width="80px%;" />
                            <col width="140px;" />
                            <col width="*%;" />
                            <col width="80px;" />
                            <col width="80px;" />
                        </colgroup>
                        <thead>
                            <tr>
                                <th>
                                    <input className="form-check-input"
                                        type="checkbox"
                                        id="alldel"
                                        onChange={(e) => { this.handleCheck_Click(e) }}
                                    />
                                </th>
                                <th>순번</th>
                                <th>상태</th>
                                <th>도매명</th>
                                <th>빌딩명</th>
                                <th>층수</th>
                                <th>호수</th>
                                <th>전화번호</th>
                                <th>주문내용</th>
                                <th> 
                                    <label>반품여부</label>
                                   <input className="form-check-input"
                                        id="allreturn"
                                        type="checkbox"
                                        onChange={(e) => { this.handleCheck_Click(e) }}
                                    />
                                </th>
                                <th>검증</th>
                            </tr>
                        </thead>
                        <tbody>
                            {Listrender }
                        </tbody>
                    </table>
                    <div className="txt">총 주문<b>{this.state.WholeDataList.length}건</b></div>
                </div>
                {this.ButtonBottom()}
                <div className="excel_data_guide pc_v">
                    <div className="title">일괄주문 작성안내</div>
                    <ul>
                        <li>{this.Uid_Type === 'SS' ? "주문입력 버튼 : 도매를 직접 검색하여 사입요청 내용을 등록합니다." : "주문입력 버튼 : 도매를 직접 검색하여 택배요청 내용을 등록합니다."}</li>
                        <li>{this.Uid_Type === 'SS' ? "삭제 버튼 : 입력된 사입주문 내역을 선택 후 삭제합니다." : "삭제 버튼 : 입력된 택배주문 내역을 선택 후 삭제합니다."} </li>
                        <li>미확인 버튼 : 주문이 입력된 후 "미확인" 버튼을 클릭하여 도매별 주문을 삭제할 수 있습니다.</li>
                        <li>{this.Uid_Type === 'SS' ? '상태 : "작업중"은 임시저장 상태이며 "완료"는 사입주문이 완료된 상태입니다.' : '상태 : "작업중"은 임시저장 상태이며 "완료"는 택배주문이 완료된 상태입니다.'}  </li>
                        <li>{this.Uid_Type === 'SS' ? '반품여부: 체크 시 사입주문의 반품 여부를 등록합니다.' : '반품여부: 체크 시 택배주문의 반품 여부를 등록합니다.'} </li>
                        <li> {this.Uid_Type === 'SS' ? '검증: "매장확인"은 매장 정보가 일치하여 사입을 요청할 수 있는 상태 이며, "미확인"은 매장 정보가 불확실하여 사입주문을 할 수 없는 상태입니다.'
                            : '검증: "매장확인"은 매장 정보가 일치하여 택배를 요청할 수 있는 상태 이며, "미확인"은 매장 정보가 불확실하여 택배주문을 할 수 없는 상태입니다.'}</li>
                    </ul>
                </div>
                <WholeInputSearch
                    id="WholeInputSearch"
                    ref={this.ref_WholeInputSearch}
                    CallBack={this.CallWholeListData}
                />
                <Alert
                    id="AlertOrderExcelTable"
                    title="등록안내"
                    content={this.state.Content}
                />
                <ExcelUpLoad
                    id="ExcelUpLoad"
                    ref={this.ref_ExcelUpLoad}
                    CallBack={this.CallExcelWholeListData}
                />
                <OrderSelect
                    id="OrderSelect"
                    ref={this.ref_OrderSelect}
                    title="날짜선택"
                    CallBack={this.CallOrderSelect}
                />
                <Confirm
                    id="ConfirmBox"
                    title={this.Uid_Type === 'SS' ? "사입요청 안내" : "택배요청 안내"}
                    content={this.Uid_Type === 'SS' ? "사입삼촌에게 사입내역이 전달됩니다.<br/>사입요청을 하시겠습니까?" : "택배삼촌에게 택배내역이 전달됩니다.<br/>택배요청을 하시겠습니까?"}
                    ConfirmClick={(e) => {
                        setTimeout(() => {
                            Big3Common.ModalClose(bootstrap, 'ConfirmBox');
                        }, 500);
                        this.handleSave_Click('send')
                    }}
                />
            </div>
        );
    }
}

                                        